import DOMPurify from "dompurify";
import "./FormatedClanak.css";
const FormattedClanak = ({ content }) => {
  const backendUrl = "";

  const adjustedContent = (content || "").replace(
    /src="\/uploads/g,
    `src="${backendUrl}/uploads`
  );

  const cleanContent = DOMPurify.sanitize(adjustedContent, {
    ALLOWED_TAGS: [
      "p",
      "b",
      "i",
      "u",
      "em",
      "strong",
      "br",
      "ul",
      "ol",
      "li",
      "h1",
      "h2",
      "h3",
      "h4",
      "a",
      "img",
      "span",
    ],
    ALLOWED_ATTR: [
      "href",
      "target",
      "rel",
      "src",
      "alt",
      "width",
      "height",
      "style","data-align",
    ],
  });

  return (
    <div
      className="formatted-content"
      style={{ textAlign: "justify" }}
      dangerouslySetInnerHTML={{ __html: cleanContent }}
    />
  );
};

export default FormattedClanak;
